module.exports = __webpack_public_path__ + "static/media/qr-apple.571cb1c6.png";